import { FC, useMemo, useRef } from 'react'
import styles from 'components/atoms/inputs/DatePicker/DateField.styl'
import { createCalendar, DateValue } from '@internationalized/date'
import { useLocale } from '@react-aria/i18n'
import { useDateFieldState } from '@react-stately/datepicker'
import { AriaDateFieldProps, useDateField } from '@react-aria/datepicker'
import { DateSegment } from 'components/atoms/inputs/DatePicker/DateSegment'

type DateFieldProps = AriaDateFieldProps<DateValue>

export const DateField: FC<DateFieldProps> = (props) => {
  const { locale } = useLocale()
  const state = useDateFieldState({
    ...props,
    locale,
    createCalendar,
  })

  const ref = useRef(null)
  const { labelProps, fieldProps } = useDateField(props, state, ref)

  const inputChild = useMemo(() => state.segments && (
    <div { ...fieldProps } ref={ ref } className={ styles.field } >
      {
        state.segments.map((segment, i) =>
          <DateSegment key={ i } segment={ segment } state={ state } />)
      }
      { state.validationState === 'invalid' && <span aria-hidden='true'>🚫</span> }
    </div>
  ), [fieldProps, state])

  return (
    <div className={ styles.wrapper }>
      <span { ...labelProps }>{ props.label }</span>
      { inputChild }
    </div>
  )
}
